// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunModifiedRecord
 */
export interface RunModifiedRecord {
    /**
     * 
     * @type {string}
     * @memberof RunModifiedRecord
     */
    primaryKeyValue: string;
    /**
     * 
     * @type {string}
     * @memberof RunModifiedRecord
     */
    tableName: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RunModifiedRecord
     */
    values: { [key: string]: string; };
}

/**
 * Check if a given object implements the RunModifiedRecord interface.
 */
export function instanceOfRunModifiedRecord(value: object): value is RunModifiedRecord {
    if (!('primaryKeyValue' in value) || value['primaryKeyValue'] === undefined) return false;
    if (!('tableName' in value) || value['tableName'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function RunModifiedRecordFromJSON(json: any): RunModifiedRecord {
    return RunModifiedRecordFromJSONTyped(json, false);
}

export function RunModifiedRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunModifiedRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryKeyValue': json['primaryKeyValue'],
        'tableName': json['tableName'],
        'values': json['values'],
    };
}

export function RunModifiedRecordToJSON(json: any): RunModifiedRecord {
    return RunModifiedRecordToJSONTyped(json, false);
}

export function RunModifiedRecordToJSONTyped(value?: RunModifiedRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primaryKeyValue': value['primaryKeyValue'],
        'tableName': value['tableName'],
        'values': value['values'],
    };
}
